export const truncate = (string: string, length: number): string => {
    if (string && string.length > length) {
        const truncated = string.substring(0, length);
        const lastSpace = truncated.lastIndexOf(' ');

        return `${truncated.substring(0, lastSpace)}...`;
    }

    return string;
};

export const escapeHtmlTags = (str: string | Array<string>): string => {
    if (!str || typeof str !== 'string') {
        return '';
    }

    const replacements = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        "'": '&#39;',
        '"': '&quot;',
    };

    return str.replace(/[&<>'"]/g, (found) => replacements[found]);
};

export const unEscapeHtml = (str: string): string => {
    const replacements = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&#39;': "'",
        '&quot;': '"',
    };

    return str.replace(/&amp;|&lt;|&gt;|&#39;|&quot;/g, (found) => replacements[found]);
};
